import gql from 'graphql-tag';

export default gql`
  mutation createOneLessonMutation(
    $course: MongoID!
    $student: MongoID
    $courseCategory: MongoID
    $isZeroLesson: Boolean
    $lessonTemplate: MongoID
  ) {
    createOneLessonMutation(
      course: $course
      student: $student
      courseCategory: $courseCategory
      isZeroLesson: $isZeroLesson
      lessonTemplate: $lessonTemplate
    ) {
      record {
        _id
      }
    }
  }
`;
